import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import {useGeneralInputSpecialCase} from "../../../../hooks/use-general-input.js";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import TimePeriodInput from "../../../../components/reports/time-period-input/time-period-input.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
  const handleSpecialInput = useGeneralInputSpecialCase(setFilters);

  return (
    <>
      <div className={`mb-2 ${minMenuHeight}`}>
        <form className={'space-y-4'}>
          <div>
            <InputDateTime
              id="dtStart"
              label="Data inicial *"
              dateFormat="L"
              selected={filters.dtStart}
              onChange={date => handleSpecialInput("dtStart", date)}
            />
          </div>
          <div>
            <InputDateTime
              id="dtEnd"
              label="Data final *"
              dateFormat="L"
              selected={filters.dtEnd}
              onChange={date => handleSpecialInput("dtEnd", date)}
            />
          </div>

          <div className="flex flex-col gap-1">
            <div className="flex flex-col gap-4">
              <TimePeriodInput filters={filters} setFilters={setFilters} singleRow={true}/>
            </div>
            <span className="italic">* Data/hora utilizada: Data de cadastro</span>
          </div>
          <div>
            <InputCheckbox
              id="archivedOccurrences"
              label="Contabilizar ocorrências arquivadas"
              checked={filters.archivedOccurrences}
              onChange={() => setFilters(prev => ({...prev, archivedOccurrences: !prev.archivedOccurrences}))}
            />
          </div>
        </form>
      </div>
    </>
  );
};

export default Filters;